// * abmeldung.digital
export const abmeldungDigitalFrontendUrlDevelopment = 'http://localhost:3000'
export const abmeldungDigitalFrontendUrlStaging = 'https://staging.abmeldung.digital'
export const abmeldungDigitalFrontendUrlProduction = 'https://www.abmeldung.digital'

export const abmeldungDigitalBackendUrlDevelopment = 'http://localhost:2030'
export const abmeldungDigitalBackendUrlStaging = 'https://staging.api.abmeldung.digital'
export const abmeldungDigitalBackendUrlProduction = 'https://api.abmeldung.digital'

export const abmeldungDigitalSupportEmail = 'support@abmeldung.digital'

export const abmeldungDigitalGoogleMeasurementIdStaging = 'G-XHLN8PWGPW'
export const abmeldungDigitalGoogleMeasurementIdProduction = 'G-RFY7STG0XD'
export const abmeldungDigitalGoogleMeasurementSecretStaging = '_xtzsRB9Q-idPIsm_St4xw'
export const abmeldungDigitalGoogleMeasurementSecretProduction = '6IP2nRNJSj2j4mV_imfxRg'

export const abmeldungDigitalPosthogKeyDevelopment = 'phc_oR3vVMFI2lHI86cV8iecdmHf1FHQghDVhXDrVQkyCp2'
export const abmeldungDigitalPosthogKeyProduction = 'phc_aN29hFsEOSp1U2xfwHxAvMckIKeBZz5u87NX4C6sUzu'

// * zulassung.digital
export const zulassungDigitalFrontendUrlDevelopment = 'http://localhost:2000'
export const zulassungDigitalFrontendUrlStaging = 'https://staging.zulassung.digital'
export const zulassungDigitalFrontendUrlProduction = 'https://www.zulassung.digital'

export const zulassungDigitalBackendUrlDevelopment = 'http://localhost:2030'
export const zulassungDigitalBackendUrlStaging = 'https://staging.api.zulassung.digital'
export const zulassungDigitalBackendUrlProduction = 'https://api.zulassung.digital'

export const zulassungDigitalGoogleMeasurementIdStaging = 'G-6N48ZHWGGP'
export const zulassungDigitalGoogleMeasurementIdProduction = 'G-3G7V1WQYQ1'
export const zulassungDigitalGoogleMeasurementSecretStaging = 'DC3uP21oT_GpLPBpZ14gnw'
export const zulassungDigitalGoogleMeasurementSecretProduction = 'WU0v_3C6SHqqy8-LS51K0w'

export const zulassungDigitalSupportEmail = 'support@zulassung.digital'

export const zulassungDigitalPosthogKeyDevelopment = 'phc_9S9FrssPCrBSA3SOZrm6jwXWbrrrg708Kn7M8q8Or1L'
export const zulassungDigitalPosthogKeyProduction = 'phc_HTdWzpo03wBPM7sVnW6LTYgHGWTbzBLHqg3vX4PdbS2'

// * business.zulassung.digital
export const businessZulassungDigitalFrontendUrlDevelopment = 'http://localhost:2045'
export const businessZulassungDigitalFrontendUrlStaging = 'https://staging.business.zulassung.digital'
export const businessZulassungDigitalFrontendUrlProduction = 'https://business.zulassung.digital'

export const businessZulassungDigitalSupportEmail = 'support@zulassung.digital'

// * kfz-abmelden.digital
export const kfzAbmeldenDigitalFrontendUrlDevelopment = 'http://localhost:2060'
export const kfzAbmeldenDigitalFrontendUrlStaging = 'https://staging.kfz-abmelden.digital'
export const kfzAbmeldenDigitalFrontendUrlProduction = 'https://www.kfz-abmelden.digital'

export const kfzAbmeldenDigitalBackendUrlDevelopment = 'http://localhost:2030'
export const kfzAbmeldenDigitalBackendUrlStaging = 'https://staging.api.kfz-abmelden.digital'
export const kfzAbmeldenDigitalBackendUrlProduction = 'https://api.kfz-abmelden.digital'

export const kfzAbmeldenDigitalGoogleMeasurementIdStaging = 'G-NLQ7DH0N5Z'
export const kfzAbmeldenDigitalGoogleMeasurementIdProduction = 'G-QWHZ9H767D'
export const kfzAbmeldenDigitalGoogleMeasurementSecretStaging = 'AqTYje66Qsm3N5ZLzdIl-w'
export const kfzAbmeldenDigitalGoogleMeasurementSecretProduction = 'JjX1Q5WWQLe2WIf5YCgxKA'

export const kfzAbmeldenDigitalSupportEmail = 'support@kfz-abmelden.digital'

// * auto-abmelden.digital
export const autoAbmeldenDigitalFrontendUrlDevelopment = 'http://localhost:2060'
export const autoAbmeldenDigitalFrontendUrlStaging = 'https://staging.auto-abmelden.digital'
export const autoAbmeldenDigitalFrontendUrlProduction = 'https://www.auto-abmelden.digital'

export const autoAbmeldenDigitalBackendUrlDevelopment = 'http://localhost:2030'
export const autoAbmeldenDigitalBackendUrlStaging = 'https://staging.api.auto-abmelden.digital'
export const autoAbmeldenDigitalBackendUrlProduction = 'https://api.auto-abmelden.digital'

export const autoAbmeldenDigitalGoogleMeasurementIdStaging = 'G-9GGQD9VB11'
export const autoAbmeldenDigitalGoogleMeasurementIdProduction = 'G-BKMJYMDWDB'
export const autoAbmeldenDigitalGoogleMeasurementSecretStaging = 'dH5V1LnfQqOBhCpVkTxZDw'
export const autoAbmeldenDigitalGoogleMeasurementSecretProduction = 'L9uqbAjPTAa2O-qh5vBaug'

export const autoAbmeldenDigitalSupportEmail = 'support@auto-abmelden.digital'

// * strassenverkehrsamt.digital
export const strassenvekehrsamtDigitalFrontendUrlDevelopment = 'http://localhost:2060'
export const strassenvekehrsamtDigitalFrontendUrlStaging = 'https://staging.strassenverkehrsamt.digital'
export const strassenvekehrsamtDigitalFrontendUrlProduction = 'https://www.strassenverkehrsamt.digital'

export const strassenvekehrsamtDigitalBackendUrlDevelopment = 'http://localhost:2030'
export const strassenvekehrsamtDigitalBackendUrlStaging = 'https://staging.api.strassenverkehrsamt.digital'
export const strassenvekehrsamtDigitalBackendUrlProduction = 'https://api.strassenverkehrsamt.digital'

export const strassenvekehrsamtDigitalGoogleMeasurementIdStaging = 'G-X1FVLLYDD3'
export const strassenvekehrsamtDigitalGoogleMeasurementIdProduction = 'G-R7S4J38VGE'
export const strassenvekehrsamtDigitalGoogleMeasurementSecretStaging = 'jBt2NMorSsq4PPJpmnvlVw'
export const strassenvekehrsamtDigitalGoogleMeasurementSecretProduction = 'nhtweozkTYunnf3vLeIH2g'

export const strassenvekehrsamtDigitalSupportEmail = 'info@strassenverkehrsamt.digital'

// * price
export const princeFrontendUrlDevelopment = 'http://localhost:2065'
export const princeFrontendUrlStaging = 'https://staging.kfz.wunschkennzeichen-reservierung.de'
export const princeFrontendUrlProduction = 'https://kfz.wunschkennzeichen-reservierung.de'

export const princeBackendUrlDevelopment = 'http://localhost:2030'
export const princeBackendUrlStaging = 'https://staging.api.wunschkennzeichen-reservierung.de'
export const princeBackendUrlProduction = 'https://api.wunschkennzeichen-reservierung.de'

export const princeGoogleMeasurementIdStaging = 'G-454KQHRWN3'
export const princeGoogleMeasurementIdProduction = 'G-WKY2EP3B31'
export const princeGoogleMeasurementSecretStaging = 'E6Z-97jMSraBQqWgNhx7dQ'
export const princeGoogleMeasurementSecretProduction = 'QVEU0ZTtRsWr3scM-dqMPA'

export const princeSupportEmail = 'support@wunschkennzeichen-reservierung.de'

// * gks-api
export const gksApiUrlDevelopment = 'http://localhost:4000'
export const gksApiUrlStaging = 'https://staging.gks-api.kennzeichenking.de'
export const gksApiUrlProduction = 'https://gks-api.kennzeichenking.de'

// * empire
export const empireBackendUrlDevelopment = 'http://localhost:3030'
export const empireBackendUrlStaging = 'https://www.staging.api.kennzeichenking.de'
export const empireBackendUrlProduction = 'https://www.api.kennzeichenking.de'

// * companies
export const blackbirdGmbH = {
  companyName: 'blackbird GmbH',
  street: 'Kienberger Allee',
  houseNumber: '4',
  postalCode: '12529',
  city: 'Schönefeld',
  ceo: 'Alexander Bender, Khoi Doan, Florian Streise',
  registerCourt: 'Amtsgericht Cottbus, HRB 17431',
  vatId: 'DE321129073'
}

export const moesiGmbH = {
  companyName: 'Mösi GmbH',
  street: 'Robert-Koch-Str.',
  houseNumber: '19',
  postalCode: '73450',
  city: 'Neresheim',
  ceo: 'Florian Streise',
  registerCourt: 'Amtsgericht Ulm, HRB 743201',
  vatId: 'DE351301698'
}

export const highnoonGmbH = {
  companyName: 'Hign Noon GmbH',
  street: 'Steimlestr.',
  houseNumber: '9',
  postalCode: '73430',
  city: 'Aalen',
  ceo: 'Alexander Bender',
  registerCourt: 'Amtsgericht Ulm, HRB 743201',
  vatId: 'DE351301663'
}

export const saisonOptions = [
  { value: '1', label: 'Januar (1)' },
  { value: '2', label: 'Februar (2)' },
  { value: '3', label: 'März (3)' },
  { value: '4', label: 'April (4)' },
  { value: '5', label: 'Mai (5)' },
  { value: '6', label: 'Juni (6)' },
  { value: '7', label: 'Juli (7)' },
  { value: '8', label: 'August (8)' },
  { value: '9', label: 'September (9)' },
  { value: '10', label: 'Oktober (10)' },
  { value: '11', label: 'November (11)' },
  { value: '12', label: 'Dezember (12)' }
]

export const abmeldungAffiliateCommission = 4
export const zulassungAffiliateCommission = 10
